import React from "react";
import LandingPage from "../LandingPage/LandingPage";
import AboutUs from "../AboutUs/AboutUs";
import ContactUs from "../ContactUs/ContactUs";
import Events from "../Events/Events";
import EventDesc from "../Events/EventDesc/EventDesc";
import Solutions from "../Solutions/Solutions";
import TermsAndConditions from "../TermsAndConditions/TermsAndConditions";
import GreenFinSummit from "../Events/GreenFinSummit/GreenFinSummit";
import Careers from "../Careers/Careers";
import CeoColumn from "../CeoColumn/CeoColumn";
import Clem from "../Clem/Clem";
import ClemAi from "../ClemAi/ClemAi";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";

import pressReleaseRoutes from "./pressRelease/pressReleaseRoutes";
import ceTransitions from "../Events/ceTransitions/ceTransitions";

type typeRoutesConfig = {
  path?: string | undefined;
  component: React.ElementType;
};

export const routes: typeRoutesConfig[] = [
  {
    path: "/",
    component: LandingPage,
  },
  {
    path: "/about-us",
    component: AboutUs,
  },
  {
    path: "/contact-us",
    component: ContactUs,
  },
  // {
  //   path: "/resources/events-overview",
  //   component: Events,
  // },
  // {
  //   path: "/resources/events",
  //   component: EventDesc,
  // },
  {
    path: "/solutions",
    component: Solutions,
  },
  {
    path: "/terms",
    component: TermsAndConditions,
  },
  {
    path: "/privacy-policy",
    component: PrivacyPolicy,
  },
  {
    path: "/resources/events/greenfin-summit",
    component: GreenFinSummit,
  },
  {
    path: "/careers",
    component: Careers,
  },
  {
    path: "/ceo-column",
    component: CeoColumn,
  },
  {
    path: "/CLEM",
    component: Clem,
  },
  {
    path: "/CLEM.ai",
    component: ClemAi,
  },
  {
    path: "/events/ai-data-centers-to-accelerate-ce-transitions",
    component: ceTransitions,
  },
  ...pressReleaseRoutes,
];
